import React from 'react';
import CustomListContainer from "../../../../components/CustomListContainer";
import CustomListItem from "../../../../components/CustomListItem";
import {ListItemText} from "@mui/material";
import CustomPhotoPicker from "../../../../components/PhotoPicker/CustomPhotoPicker";
import {ACTION_MODEL} from "../../../../Helpers/ActionModel";
import {FILE_TYPE} from "../../../../Helpers/fileType";
import routes from "../../../../Routes/routes";
import {downloadPrivacyDocs} from "../../../Dashboard/Visitor/External/Model/Model";
import {useTranslation} from "react-i18next";
import {LinkIconsOptions, UserDocumentIcon} from "../../../../components/buttons/IconButtons";
import CustomButtonLink from "../../../../components/buttons/CustomButtonLink";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 */
const ResidentWhiteListAutomatic = (
    {
        photoPickerFile,
        setPhotoPickerFile
    }
) => {
    const { t } = useTranslation();

    return (
        <>
            <div className={"row my-3"}>
                <div className={"d-flex align-items-center"}>
                    <div className={"mr-2"}><UserDocumentIcon width={16} height={16}/></div>
                    <p className={"fs-14px ibl-font-w-600"}>
                        {t('to_upload_the_white_list_of_users_authorized_to_register_in_this_building_follow_the_steps_below')}
                    </p>
                </div>

                <div className={"col-12 pl-5"}>
                    <CustomListContainer styleType={"disc"}>
                        <CustomListItem key={1} display={'list-item'} classes={"p-0 font-color-shades-500"}>
                            <div className={"d-inline-flex align-items-center"}>
                                <ListItemText
                                    primary={t('click_to_download_the_template')}
                                    primaryTypographyProps={{ className: 'ibl-font-w-400' }}
                                />
                                <CustomButtonLink
                                    id='rwla_download'
                                    Icon={LinkIconsOptions}
                                    onClick={() => {
                                        downloadPrivacyDocs(routes.docs.residentsWhiteListTemplate, t("white_list_template"))
                                    }}
                                    name={"white_list_template"}
                                    splitName={false}
                                    className='btn-background-transparent ml-1 py-0'
                                    iconProps={'btn-icon-svg-12px'}
                                />
                            </div>
                        </CustomListItem>
                        <CustomListItem key={2} display={'list-item'} classes={"p-0"} textClasses={"ibl-font-w-400 font-color-shades-500"} text={t('fill_on_it_the_data_and_make_sure_you_are_following_the_correct_way_to_fill_it')}/>
                        <CustomListItem key={3} display={'list-item'} classes={"p-0"} textClasses={"ibl-font-w-400 font-color-shades-500"} text={t('drag_&_drop_the_file_or_click_on_the_shape_to_search_on_the_explorer')}/>
                    </CustomListContainer>
                </div>
                <div className={"col-12"}>
                    <CustomPhotoPicker
                        id='fp_rwla_upload_white_list'
                        photoPicker={photoPickerFile}
                        setPhotoPicker={setPhotoPickerFile}
                        actionModel={ACTION_MODEL.CREATE}
                        accept={{ ...FILE_TYPE.XLSX }}
                        required={false}
                        classWith={'w-100'}
                        showPreview={false}
                    />
                </div>
            </div>
        </>
    )
}


export default ResidentWhiteListAutomatic
